import {webRequest, webNoTokenRequest} from '../api'

// 入住點交頁面 {contractSeq: String}
export function getCheckInPage(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/checkIn/page',
        method:'get',
        params: params
    })
}
// 租約管理-已建立 {page: Number}
export function getLeaseProcessTableList(page = 1) {
    return webRequest({
        url:'/v1/oauth/management/contract/inProgressContracts',
        method:'get',
        params: { page },
    })
}
// 租約管理-待租客確認 {page: Number}
export function getLeaseBeSigned(page = 1) {
    return webRequest({
        url:'/v1/oauth/management/contract/paperContracts',
        method:'get',
        params: { page },
    })
}
// 租約管理-待租客確認 {page: Number}
export function getLeaseFinishedTableList(page = 1) {
    return webRequest({
        url:'/v1/oauth/management/contract/finishedContracts',
        method:'get',
        params: { page },
    })
}
// 房東發起入住點交
// {
//     "contractSeq" : "CT210618000005",
//     "waterMeter" : 10,
//     "electricityMeter" : 20,
//     "gasMeter" : 30
// }
export function checkIn(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/check/in',
        method:'post',
        data: data,
    })
}
// 取得合約房源服務費率 {contractSeq: String}
export function getServiceFeeRate(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/getServiceFeeRate',
        method:'get',
        params: params,
    })
}
// 取得合約PDF {contractCid: String}
export function getContractPDF(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/getPaperContractByContractCid',
        method:'get',
        responseType: "arraybuffer",
        params: params,
    })
}
// 取得合約PDF {paperContractCid: String}
export function getPaperContractPDF(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/getPaperContractByPaperContractCid',
        method:'get',
        responseType: "arraybuffer",
        params: params,
    })
}
// 新增紙本合約-通知租客
export function paperContractNotification(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/notification',
        method:'post',
        data: data,
    })
}
// 刪除紙本合約
export function delPaperContract(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/delete/paperContract',
        method:'post',
        data: data,
    })
}
// 退租點交申訴
export function setReleaseAppeal(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/releaseAppeal',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/leaseMgt.js